<template>
  <v-container>
    <h1>Set Current Devotional</h1>
    <v-form>
      <v-alert
        v-model="isError"
        dismissible
        type="error"
        transition="fade-transition"
      >
        {{ errMessage }}
        <ul>
          <li :key="i" v-for="(error, i) in errors">
            {{ error }}
          </li>
        </ul>
      </v-alert>

      <devotional-set-select
        :excludeFixed="true"
        v-model="set"
      />

      <devotional-select
        :set="set"
        v-model="devotional"
      />

      <v-btn
        @click="submit"
      >Set</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import DevotionalSetSelect from '@/components/devotional-set-select'
import DevotionalSelect from '@/components/devotional-select'

export default {
  data: () => ({
    set: null,
    devotional: null,

    isError: false,
    errMessage: null,
    errors: {}
  }),
  mounted: function () {
    let _this = this
    this.axios.get('/devotionals/marker')
      .then(function (res) {
        if (res.data) {
          _this.set = res.data.setID
          _this.devotional = res.data.devoID
        }
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    submit: function (ev) {
      var _this = this

      this.axios.post('/devotionals/marker', {
        id: this.devotional
      })
        .then(function (res) {
          _this.$router.push('/admin/devotionals')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  components: {
    DevotionalSetSelect,
    DevotionalSelect
  }
}
</script>
